import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { SeoManager } from '../seo';
import { buildCanonicalUrl } from '../seo/siteConfig';
import { buildArticleSchema } from '../seo/structuredData';
import blogData from '../blog/articles';
import BlogByline from '../components/BlogByline';
import NotFoundPage from './NotFoundPage';
import '../styles/Blog.css';

const renderParts = (parts) =>
  parts.map((part, index) => {
    if (typeof part === 'string') return <React.Fragment key={index}>{part}</React.Fragment>;
    return (
      <Link key={index} to={part.to}>
        {part.text}
      </Link>
    );
  });

export default function BlogArticlePage() {
  const { slug } = useParams();
  const article = blogData.articles.find((item) => item.slug === slug);

  if (!article) return <NotFoundPage />;

  const path = `/blog/${article.slug}`;
  const canonicalUrl = buildCanonicalUrl(path);
  const related = blogData.articles.filter((item) => item.slug !== article.slug).slice(0, 3);

  return (
    <main className="blog-page">
      <SeoManager
        title={article.title}
        description={article.description}
        keywords={article.keywords}
        path={path}
        ogType="article"
        structuredData={buildArticleSchema({
          title: article.title,
          description: article.description,
          url: canonicalUrl,
          datePublished: article.datePublished,
          authorName: blogData.author.name,
          authorJobTitle: blogData.author.jobTitle,
        })}
      />
      <article className="container">
        <p className="blog-meta">
          <Link to="/blog/">Blog</Link>
          {' · '}
          <Link to={article.gamePath}>{article.gameName}</Link>
        </p>
        <h1>{article.title}</h1>
        <BlogByline datePublished={article.datePublished} />
        <Link className="blog-play" to={article.gamePath}>
          Play {article.gameName}
        </Link>
        {article.blocks.map((block, index) => {
          if (block.type === 'h2') return <h2 key={index}>{block.text}</h2>;
          if (block.type === 'ul') {
            return (
              <ul key={index}>
                {block.items.map((item) => (
                  <li key={item}>{item}</li>
                ))}
              </ul>
            );
          }
          if (block.parts) {
            return <p key={index}>{renderParts(block.parts)}</p>;
          }
          return <p key={index}>{block.text}</p>;
        })}
        <h2>More guides</h2>
        <ul className="blog-related">
          {related.map((item) => (
            <li key={item.slug}>
              <Link to={`/blog/${item.slug}/`}>{item.title}</Link>
            </li>
          ))}
          <li>
            <Link to="/blog/">All blog posts</Link>
          </li>
        </ul>
      </article>
    </main>
  );
}
